import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import Layout from './components/Layout';

// Public Pages
import VehiclePage from './pages/public/VehiclePage';

// Admin Pages
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import VehiclesPage from './pages/admin/VehiclesPage';
import VehicleFormPage from './pages/admin/VehicleFormPage';
import UsersPage from './pages/admin/UsersPage';
import BulkImportPage from './pages/admin/BulkImportPage';

import 'bootstrap/dist/css/bootstrap.min.css';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes with Global Layout */}
          <Route element={<Layout />}>
            <Route path="/car" element={<VehiclePage />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<LoginPage />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="vehicles" element={<VehiclesPage />} />
            <Route path="vehicles/new" element={<VehicleFormPage />} />
            <Route path="vehicles/:id" element={<VehicleFormPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="bulk-import" element={<BulkImportPage />} />
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/car" replace />} />
          <Route path="*" element={<Navigate to="/car" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
